// extracted by mini-css-extract-plugin
module.exports = {"message":"ErrorMessagePopup_message__2bM2Y","container":"ErrorMessagePopup_container__3oF_5"};